var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.011,
    height: 15.011,
    viewBox: "0 0 15.011 15.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f44336}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chrome",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    d: "M66.458 4.691H59.5a2.814 2.814 0 0 0-2.458 4.19l-3.474-5.966a7.5 7.5 0 0 1 12.89 1.776z",
    className: "cls-1",
    transform: "translate(-51.997 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7775",
    fill: "#ffc107",
    d: "M232.464 162.835a7.512 7.512 0 0 1-7.505 7.505 6.7 6.7 0 0 1-.938-.063l3.377-6.035a2.821 2.821 0 0 0-1.032-3.846 2.788 2.788 0 0 0-1.4-.375h6.949a7.4 7.4 0 0 1 .549 2.814z",
    transform: "translate(-217.453 -155.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    fill: "#4caf50",
    d: "M9.946 105.432l-3.377 6.035h-.007a7.5 7.5 0 0 1-4.991-12.033l3.478 5.966.019.031a2.814 2.814 0 0 0 4.878 0z",
    transform: "translate(0 -96.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    d: "M165.166 164.242a2.814 2.814 0 0 1-4.878 0l-.019-.031a2.814 2.814 0 0 1 2.458-4.19h.006a2.788 2.788 0 0 1 1.4.375 2.821 2.821 0 0 1 1.033 3.846z",
    className: "cls-1",
    transform: "translate(-155.22 -155.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    fill: "#2196f3",
    d: "M165.166 164.242a2.814 2.814 0 0 1-4.878 0l-.019-.031a2.814 2.814 0 0 1 2.458-4.19h.006a2.788 2.788 0 0 1 1.4.375 2.821 2.821 0 0 1 1.033 3.846z",
    transform: "translate(-155.22 -155.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    fill: "#fafafa",
    d: "M152.395 155.609a3.1 3.1 0 0 1-1.553-.417 3.13 3.13 0 1 1 4.274-1.147 3.145 3.145 0 0 1-2.721 1.564zm.016-5.629a2.5 2.5 0 1 0 2.162 3.753 2.5 2.5 0 0 0-2.161-3.753z",
    transform: "translate(-144.899 -144.976)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.58deef5b00ae2ead64b00c2bb2725c8a.svg";
export { ForwardRef as ReactComponent };